<template>
  <ul :class="$style.attrs">
    <li v-if="productNo" :class="$style.attr">
      <div :class="$style.attr_label">产品编号</div>
      <div :class="$style.attr_value" class="cursor-pointer transition-colors hover:text-primary" v-clipboard="onCopy" v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError"><span>{{productNo}}</span><i class="ml-2 ficon ficon-fuzhi" /></div>
    </li>
    <li v-if="departure" :class="$style.attr">
      <div :class="$style.attr_label">出发地</div>
      <div :class="$style.attr_value">{{departure}}</div>
    </li>
    <li v-if="ports.length" :class="$style.attr" class="flex-1">
      <div :class="$style.attr_label">停靠港</div>
      <div :class="$style.attr_value">{{ ports.join(',') }}</div>
    </li>
  </ul>
</template>
<script>
import { defineComponent } from "@nuxtjs/composition-api";
import clipboard from "@/directives/clipboard";
import useMessage from "~/composables/useMessage";
export default defineComponent({
  directives: {
    clipboard
  },
	props: {
		productNo: String,
		departure: String,
		ports: Array
	},
  setup(props) {
    const $message = useMessage();
    return {
      onCopy() {
        return props.productNo
      },
      onCopySuccess() {
        $message.success('复制成功')
      },
      onCopyError() {
        $message.error('复制失败')
      }
    }
  },
  // computed: {
  //   portStr() {
  //     return this.ports.map(port => port.itinerary).join(',')
  //   }
  // }
});
</script>
<style lang="scss" module>
.attrs {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.attr:last-child {
  border-style: none;
}
.attr {
  border-right-width: 1px;
  padding-left: 1rem;
  padding-right: 1rem;
}
.attr_label {
  --tw-text-opacity: 1;
  color: rgba(151, 154, 168, var(--tw-text-opacity));
}
.attr_value {
  margin-top: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
</style>